export default {
  avatar: {
    background: "#FFF",
    display: "flex",
    alignItems: "center",
    height: "85px",
    padding: 15,
    boxShadow:
      "rgba(0, 0, 0, 0.08) 0px 3px 6px, rgba(0, 0, 0, 0.1) 0px 3px 6px",
    borderBottom: "1px solid #CCC"
  }
};



// WEBPACK FOOTER //
// ./src/components/support/sidebar/style.js